<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
    <main class="container py-4">

        <!-- Page Header -->
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="fw-bold mb-0">Currencies</h4>
                <div class="text-muted small">Manage supported trading currencies</div>
            </div>
        </div>

        <div class="row g-4">
            <!-- LEFT: Add Currency -->
            <div class="col-12 col-lg-3">

                <div class="card shadow-sm border-0">
                    <div class="card-body">

                        <h6 class="fw-semibold mb-3">Add Currency</h6>

                        <form [formGroup]="currencyForm" (ngSubmit)="addCurrency()">

                            <!-- Currency Name -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Currency Name</label>
                                <input type="text" class="form-control" formControlName="currencyName"
                                    placeholder="e.g. US Dollars" [ngClass]="{
                       'is-invalid': currencyName?.invalid && (currencyName?.dirty || currencyName?.touched)
                     }">

                                <div *ngIf="currencyName?.invalid && (currencyName?.dirty || currencyName?.touched)" class="invalid-feedback">
                                    <div *ngIf="currencyName?.errors?.['required']">
                                        Currency name is required
                                    </div>
                                </div>
                            </div>

                            <!-- ISO Code -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">ISO Code</label>
                                <input type="text" maxlength="3" class="form-control text-uppercase"
                                    formControlName="currencyCode" placeholder="USD" [ngClass]="{
                       'is-invalid': currencyCode?.invalid && (currencyCode?.dirty || currencyCode?.touched)
                     }">

                                <div *ngIf="currencyCode?.invalid && (currencyCode?.dirty || currencyCode?.touched)" class="invalid-feedback">
                                    <div *ngIf="currencyCode?.errors?.['required']">
                                        ISO code is required
                                    </div>
                                    <div *ngIf="currencyCode?.errors?.['maxlength']">
                                        ISO code must be 2 characters
                                    </div>
                                </div>
                            </div>

                            <!-- Symbol -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Symbol</label>
                                <input type="text" class="form-control text-uppercase"
                                    formControlName="symbol" placeholder="NG" [ngClass]="{
                       'is-invalid': symbol?.invalid && (symbol?.dirty || symbol?.touched)
                     }">

                                <div *ngIf="symbol?.invalid && (symbol?.dirty || symbol?.touched)" class="invalid-feedback">
                                    <div *ngIf="symbol?.errors?.['required']">
                                        Symbol is required
                                    </div>
                                </div>
                            </div>

                            <!-- Decimal Place  -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Decimal Places</label>
                                <input type="number" class="form-control text-uppercase"
                                    formControlName="decimalPlaces" placeholder="2" [ngClass]="{
                       'is-invalid': decimalPlaces?.invalid && (decimalPlaces?.dirty || decimalPlaces?.touched)
                     }">

                                <div *ngIf="decimalPlaces?.invalid && (decimalPlaces?.dirty || decimalPlaces?.touched)" class="invalid-feedback">
                                    <div *ngIf="decimalPlaces?.errors?.['required']">
                                        Decimal places is required
                                    </div>
                                </div>
                            </div>

                            <!-- Delimiter  -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Delimiter</label>
                                <input type="text" class="form-control text-uppercase"
                                    formControlName="delimiter" placeholder="," [ngClass]="{
                       'is-invalid': delimiter?.invalid && (delimiter?.dirty || delimiter?.touched)
                     }">

                                <div *ngIf="delimiter?.invalid && (delimiter?.dirty || delimiter?.touched)" class="invalid-feedback">
                                    <div *ngIf="delimiter?.errors?.['required']">
                                        Delimiter is required
                                    </div>
                                </div>
                            </div>

                            <!-- Minimum Deposit -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Minimum Deposit</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="minDeposit" placeholder="0.00" [ngClass]="{
                       'is-invalid': minDeposit?.invalid && (minDeposit?.dirty || minDeposit?.touched)
                     }">

                                <div *ngIf="minDeposit?.invalid && (minDeposit?.dirty || minDeposit?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="minDeposit?.errors?.['required']">
                                        Minimum deposit is required
                                    </div>
                                    <div *ngIf="minDeposit?.errors?.['min']">
                                        Minimum deposit must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Pre-KYC Maximum Deposit -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Pre-KYC Maximum Deposit</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="preKycMaxDeposit" placeholder="0.00" [ngClass]="{
                       'is-invalid': preKycMaxDeposit?.invalid && (preKycMaxDeposit?.dirty || preKycMaxDeposit?.touched)
                     }">

                                <div *ngIf="preKycMaxDeposit?.invalid && (preKycMaxDeposit?.dirty || preKycMaxDeposit?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="preKycMaxDeposit?.errors?.['required']">
                                        Pre-KYC Maximum deposit is required
                                    </div>
                                    <div *ngIf="preKycMaxDeposit?.errors?.['min']">
                                        Pre-KYC Maximum deposit must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Minimum Order -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Minimum Order</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="minOrder" placeholder="0.00" [ngClass]="{
                       'is-invalid': minOrder?.invalid && (minOrder?.dirty || minOrder?.touched)
                     }">

                                <div *ngIf="minOrder?.invalid && (minOrder?.dirty || minOrder   ?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="minOrder?.errors?.['required']">
                                        Minimum order is required
                                    </div>
                                    <div *ngIf="minOrder?.errors?.['min']">
                                        Minimum order must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Pre-KYC Maximum Order -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Pre-KYC Maximum Order</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="preKycMaxOrder" placeholder="0.00" [ngClass]="{
                       'is-invalid': preKycMaxOrder?.invalid && (preKycMaxOrder?.dirty || preKycMaxOrder  ?.touched)
                     }">

                                <div *ngIf="preKycMaxOrder?.invalid && (preKycMaxOrder?.dirty || preKycMaxOrder?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="preKycMaxOrder?.errors?.['required']">
                                        Pre-KYC Maximum order is required
                                    </div>
                                    <div *ngIf="preKycMaxOrder?.errors?.['min']">
                                        Pre-KYC Maximum order must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Minimum Withdrawal -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Minimum Withdrawal</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="minWithdraw" placeholder="0.00" [ngClass]="{
                       'is-invalid': minWithdraw?.invalid && (minWithdraw?.dirty || minWithdraw?.touched)
                     }">

                                <div *ngIf="minWithdraw?.invalid && (minWithdraw?.dirty || minWithdraw?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="minWithdraw?.errors?.['required']">
                                        Minimum withdrawal is required
                                    </div>
                                    <div *ngIf="minWithdraw?.errors?.['min']">
                                        Minimum withdrawal must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Pre-KYC Maximum Withdrawal -->
                            <div class="mb-3">
                                <label class="form-label small text-muted">Pre-KYC Maximum Withdrawal</label>
                                <input type="number" step="0.01" class="form-control text-uppercase"
                                    formControlName="preKycMaxWithdraw" placeholder="0.00" [ngClass]="{
                       'is-invalid': preKycMaxWithdraw?.invalid && (preKycMaxWithdraw?.dirty || preKycMaxWithdraw?.touched)
                     }">

                                <div *ngIf="preKycMaxWithdraw?.invalid && (preKycMaxWithdraw?.dirty || preKycMaxWithdraw?.touched)"
                                    class="invalid-feedback">
                                    <div *ngIf="preKycMaxWithdraw?.errors?.['required']">
                                        Pre-KYC Maximum withdrawal is required
                                    </div>
                                    <div *ngIf="preKycMaxWithdraw?.errors?.['min']">
                                        Pre-KYC Maximum withdrawal must be at least 0
                                    </div>
                                </div>
                            </div>

                            <!-- Submit -->
                            <button type="submit" class="btn btn-primary w-100"
                                [disabled]="currencyForm.invalid || loading">
                                <span *ngIf="!loading">Add Currency</span>
                                <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
                            </button>

                        </form>
                    </div>
                </div>

            </div>

            <!-- RIGHT: Countries List -->
            <div class="col-12 col-lg-9">

                <div class="card shadow-sm border-0">
                    <div class="card-body">

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-semibold mb-0">All Currencies</h6>
                            <span class="badge text-bg-secondary">
                                {{ metaCurrency?.totalRows | number : '1.0-0' }}
                            </span>
                        </div>

                        <div class="table-responsive">

                            <table class="table table-hover align-middle">

                                <thead class="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Status</th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr *ngFor="let currency of currencies">
                                        <td class="fw-semibold">{{ currency.currencyName }}</td>
                                        <td>{{ currency.currencyCode }}</td>

                                        <td>
                                            <span [class]="getStatusClass(currency.status)">
                                                {{ currency.status }}
                                            </span>
                                        </td>

                                        <td class="text-end">
                                            <button type="button"
                                                class="btn btn-sm btn-outline-secondary me-2"
                                                (click)="openCurrencyModal(currency)">
                                                View
                                            </button>
                                            <button class="btn btn-sm btn-outline-primary me-2"
                                                (click)="editCurrency(currency)">
                                                Edit
                                            </button>

                                            <button class="btn btn-sm btn-outline-danger"
                                                [disabled]="deletingId === currency.id"
                                                (click)="deleteCurrency(currency.id)">
                                                Delete
                                            </button>

                                        </td>
                                    </tr>

                                    <tr *ngIf="!currencies || currencies.length === 0">
                                        <td colspan="4" class="text-center text-muted py-4">
                                            No currencies added yet
                                        </td>
                                    </tr>

                                </tbody>

                            </table>
                            <app-pagination *ngIf="metaCurrency && metaCurrency.totalRows > 0" [url]='url' [counts]='metaCurrency!' (refresh)="listCurrencies($event)"></app-pagination>

                        </div>

                    </div>
                </div>

            </div>

        </div>

        <app-footer></app-footer>
    </main>
</div>


<!-- EDIT MODAL -->
<div class="modal fade" id="editCurrencyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">

            <div class="modal-header" style="background:#0b1f3a;">
                <h6 class="modal-title text-white fw-semibold">Edit Currency</h6>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="closeEditModal()"></button>
            </div>

            <form [formGroup]="editCurrencyForm" (ngSubmit)="saveCurrencyEdits()">

                <div class="modal-body">

                    <!-- Hidden id -->
                    <input type="hidden" formControlName="id">

                    <div class="mb-3">
                        <label class="form-label small text-muted">Currency Name</label>
                        <input type="text" class="form-control" formControlName="currencyName"
                            [ngClass]="{ 'is-invalid': editCurrencyName?.invalid && (editCurrencyName?.dirty || editCurrencyName?.touched) }" />

                        <div *ngIf="editCurrencyName?.invalid && (editCurrencyName?.dirty || editCurrencyName?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editCurrencyName?.errors?.['required']">Currency name is required</div>
                        </div>
                    </div>

                    <!-- Symbol  -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Currency Symbol</label>
                        <input type="text" class="form-control text-uppercase"
                            formControlName="symbol" placeholder="0.00" [ngClass]="{
                       'is-invalid': editSymbol?.invalid && (editSymbol?.dirty || editSymbol?.touched)
                     }">

                        <div *ngIf="editSymbol?.invalid && (editSymbol?.dirty || editSymbol?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editSymbol?.errors?.['required']">
                                Currency symbol is required
                            </div>
                        </div>
                    </div>

                    <!-- Decimal Place -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Decimal Places</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="decimalPlaces" placeholder="2" [ngClass]="{
                       'is-invalid': editDecimalPlaces?.invalid && (editDecimalPlaces?.dirty || editDecimalPlaces?.touched)
                     }">

                        <div *ngIf="editDecimalPlaces?.invalid && (editDecimalPlaces?.dirty || editDecimalPlaces?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editDecimalPlaces?.errors?.['required']">
                                Decimal places is required
                            </div>
                            <div *ngIf="editDecimalPlaces?.errors?.['min']">
                                Decimal places must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Delimiter  -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Currency Delimiter</label>
                        <input type="text" class="form-control text-uppercase"
                            formControlName="delimiter" placeholder="," [ngClass]="{
                       'is-invalid': editDelimiter?.invalid && (editDelimiter?.dirty || editDelimiter?.touched)
                     }">

                        <div *ngIf="editDelimiter?.invalid && (editDelimiter?.dirty || editDelimiter?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editDelimiter?.errors?.['required']">
                                Currency delimiter is required
                            </div>
                        </div>
                    </div>

                    <!-- Minimum Deposit -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Minimum Deposit</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="minDeposit" placeholder="0.00" [ngClass]="{
                       'is-invalid': editMinDeposit?.invalid && (editMinDeposit?.dirty || editMinDeposit?.touched)
                     }">

                        <div *ngIf="editMinDeposit?.invalid && (editMinDeposit?.dirty || editMinDeposit?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editMinDeposit?.errors?.['required']">
                                Minimum deposit is required
                            </div>
                            <div *ngIf="editMinDeposit?.errors?.['min']">
                                Minimum deposit must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Pre-KYC Maximum Deposit -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Pre-KYC Maximum Deposit</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="preKycMaxDeposit" placeholder="0.00" [ngClass]="{
                       'is-invalid': editPreKycMaxDeposit?.invalid && (editPreKycMaxDeposit?.dirty || editPreKycMaxDeposit?.touched)
                     }">

                        <div *ngIf="editPreKycMaxDeposit?.invalid && (editPreKycMaxDeposit?.dirty || editPreKycMaxDeposit?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editPreKycMaxDeposit?.errors?.['required']">
                                Pre-KYC Maximum deposit is required
                            </div>
                            <div *ngIf="editPreKycMaxDeposit?.errors?.['min']">
                                Pre-KYC Maximum deposit must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Minimum Order -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Minimum Order</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="minOrder" placeholder="0.00" [ngClass]="{
                       'is-invalid': editMinOrder?.invalid && (editMinOrder?.dirty || editMinOrder?.touched)
                     }">

                        <div *ngIf="editMinOrder?.invalid && (editMinOrder?.dirty || editMinOrder?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editMinOrder?.errors?.['required']">
                                Minimum order is required
                            </div>
                            <div *ngIf="editMinOrder?.errors?.['min']">
                                Minimum order must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Pre-KYC Maximum Order -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Pre-KYC Maximum Order</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="preKycMaxOrder" placeholder="0.00" [ngClass]="{
                       'is-invalid': editPreKycMaxOrder?.invalid && (editPreKycMaxOrder?.dirty || editPreKycMaxOrder?.touched)
                     }">

                        <div *ngIf="editPreKycMaxOrder?.invalid && (editPreKycMaxOrder?.dirty || editPreKycMaxOrder?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editPreKycMaxOrder?.errors?.['required']">
                                Pre-KYC Maximum order is required
                            </div>
                            <div *ngIf="editPreKycMaxOrder?.errors?.['min']">
                                Pre-KYC Maximum order must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Minimum Withdrawal -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Minimum Withdrawal</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="minWithdraw" placeholder="0.00" [ngClass]="{
                       'is-invalid': editMinWithdraw?.invalid && (editMinWithdraw?.dirty || editMinWithdraw?.touched)
                     }">

                        <div *ngIf="editMinWithdraw?.invalid && (editMinWithdraw?.dirty || editMinWithdraw?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editMinWithdraw?.errors?.['required']">
                                Minimum withdrawal is required
                            </div>
                            <div *ngIf="editMinWithdraw?.errors?.['min']">
                                Minimum withdrawal must be at least 0
                            </div>
                        </div>
                    </div>

                    <!-- Pre-KYC Maximum Withdrawal -->
                    <div class="mb-3">
                        <label class="form-label small text-muted">Pre-KYC Maximum Withdrawal</label>
                        <input type="number" class="form-control text-uppercase"
                            formControlName="preKycMaxWithdraw" placeholder="0.00" [ngClass]="{
                       'is-invalid': editPreKycMaxWithdraw?.invalid && (editPreKycMaxWithdraw?.dirty || editPreKycMaxWithdraw?.touched)
                     }">

                        <div *ngIf="editPreKycMaxWithdraw?.invalid && (editPreKycMaxWithdraw?.dirty || editPreKycMaxWithdraw?.touched)"
                            class="invalid-feedback">
                            <div *ngIf="editPreKycMaxWithdraw?.errors?.['required']">
                                Pre-KYC Maximum withdrawal is required
                            </div>
                            <div *ngIf="editPreKycMaxWithdraw?.errors?.['min']">
                                Pre-KYC Maximum withdrawal must be at least 0
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" (click)="closeEditModal()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="editCurrencyForm.invalid || loadingEdit">
                        <span *ngIf="!loadingEdit">Save Changes</span>
                        <span *ngIf="loadingEdit" class="spinner-border spinner-border-sm"></span>
                    </button>
                </div>

            </form>

        </div>
    </div>
</div>

<!-- CURRENCY DETAILS MODAL -->
<div class="modal fade" id="currencyDetailsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow">

      <div class="modal-header" style="background:#0b1f3a;">
        <div>
          <h6 class="modal-title text-white fw-semibold mb-0">Currency</h6>
          <div class="text-white-50 small">
            {{ selectedCurrency?.currencyCode }} • {{ selectedCurrency?.currencyName }}
          </div>
        </div>

        <button type="button"
                class="btn-close btn-close-white"
                aria-label="Close"
                (click)="closeCurrencyModal()"></button>
      </div>

      <div class="modal-body">

        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <button class="nav-link active"
                    data-bs-toggle="tab"
                    data-bs-target="#currencyTabDetails"
                    type="button">
              Details
            </button>
          </li>
        </ul>

        <div class="tab-content pt-3">

          <!-- DETAILS -->
          <div class="tab-pane fade show active" id="currencyTabDetails">
            <div class="row g-3">
              <div class="col-12 col-lg-6">
                <div class="p-3 rounded-3 border bg-body">
                  <div class="fw-semibold mb-2">Overview</div>

                  <div class="small text-muted">Code</div>
                  <div class="fw-semibold text-uppercase">{{ selectedCurrency?.currencyCode }}</div>

                  <hr class="my-3">

                  <div class="small text-muted">Name</div>
                  <div class="fw-semibold">{{ selectedCurrency?.currencyName }}</div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Symbol</span>
                    <span class="fw-semibold">{{ selectedCurrency?.symbol || '—' }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Decimals Place</span>
                    <span class="fw-semibold">{{ selectedCurrency?.decimalPlaces ?? '—' }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Status</span>
                    <span class="badge"
                      [ngClass]="getStatusClass(selectedCurrency?.status ?? '')">
                  {{ selectedCurrency?.status }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-6">
                <div class="p-3 rounded-3 border bg-body">
                  <div class="fw-semibold mb-2">Meta</div>

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Min Deposit</span>
                    <span class="fw-semibold">{{ selectedCurrency?.minDeposit | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Pre-KYC Max Deposit</span>
                    <span class="fw-semibold">{{ selectedCurrency?.preKycMaxDeposit | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Min Order</span>
                    <span class="fw-semibold">{{ selectedCurrency?.minOrder | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Pre-KYC Max Order</span>
                    <span class="fw-semibold">{{ selectedCurrency?.preKycMaxOrder | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Min Withdrawal</span>
                    <span class="fw-semibold">{{ selectedCurrency?.minWithdraw | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Pre-KYC Max Withdrawal</span>
                    <span class="fw-semibold">{{ selectedCurrency?.preKycMaxWithdraw | smartAmount }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Created</span>
                    <span class="fw-semibold">{{ selectedCurrency?.createdAt | date:'medium' }}</span>
                  </div>

                  <hr class="my-3">

                  <div class="d-flex justify-content-between">
                    <span class="small text-muted">Last Modified</span>
                    <span class="fw-semibold">{{ selectedCurrency?.lastUpdatedAt | date:'medium' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeCurrencyModal()">
          Close
        </button>
      </div>

    </div>
  </div>
</div>